import styled from "styled-components";
import { globalTheme } from "@clds/component-theme";
import { StyledGridItemWrapper } from "~/src/root/components/StyledGridItemWrapper/StyledGridItemWrapper";

export const StyledGridItem: ComponentType<any> = styled(StyledGridItemWrapper)`
    margin-left: ${globalTheme.spacing.sm};
`;
